import { Button } from '@heroui/react';
import { SearchBar } from '@shared/ui/common/search-bar';
import { ArrowLeft2 } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';

export const SearchNavbar = ({
  onChange,
}: {
  onChange?: (value: string) => void;
}) => {
  const navigate = useNavigate();
  return (
    <div
      className="w-full flex h-[68px] py-3 items-center gap-x-2 -ml-2
          bg-white fixed top-0 left-0 right-0 z-10 px-4
        "
    >
      <Button isIconOnly variant="light" onPress={() => navigate(-1)}>
        <ArrowLeft2 size="24" color="#222222" />
      </Button>

      <SearchBar onChange={onChange} />
    </div>
  );
};
